module.exports = __webpack_public_path__ + "static/media/ajuta-sa-beau-apa.3a0e6ad1.jpeg";